<template>
  <div class="paduser">
    <div class="paduser_item">
      <div style="display:flex;height:auto;align-items:normal;" class="fx__bgcolor item__container" @click="PadUserDetails">

        <core-avatar :size="50" :userid="$store.state.core.user.userid" :username="$store.state.core.user.cnname" />
        <div class="user__right">
          <span class="fx__text_middle" style="font-weight: bold;">昵称:{{cnname}}</span>
          <div style="display:flex;justify-content:space-between;align-items:center;">
            账号:{{username}}
            <i class="fa fa-angle-right" style="font-size:18px;"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="paduser_item">
      <div @click="$router.push({name:'app-pad-userSettings'})" class="fx__bgcolor item__container">
        个人设定
        <i class="fa fa-angle-right" style="font-size:18px;"></i>
      </div>
    </div>

    <div class="paduser_item" v-for="(item, index) in list" :key="index">
      <div @click="onselect(item)" class="fx__bgcolor item__container">
        {{item.title}}
        <i class="fa fa-angle-right" style="font-size:18px;"></i>
      </div>
    </div>

    <!-- <div class="paduser_item">
      <div style="justify-content: center;" @click="clearStorage" class="fx__bgcolor item__container fx__text_warn">
        清除缓存
      </div>
    </div> -->

    <div class="paduser_item">
      <div class="fx__bgcolor item__container" @click="modal6 = true" style="justify-content: center;">安全退出</div>
    </div>
    <Modal v-model="modal6" width="50%" title="提示" class-name="vertical-center-modal pad-modal" @on-ok="logout">
      <p>您确定要退出登录吗？</p>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      cnname: "",
      username: "",
      userid: "",
      // createAt: "",
      modal6: false,
      //  {
      //     name: "修改密码",
      //     icon: "angle-right",
      //     url: "core-accountSetting"
      //   }
    }
  },
  methods: {
    clearStorage() {
      let _this = this
      if (typeof plus != "undefined") {
        plus.storage.clearAsync(
          function () {
            _this.$Message.success("清除缓存成功")
          },
          function (e) {
            _this.$Message.error("clearAsync failed: " + JSON.stringify(e))
          }
        )
      } else {
        _this.$Message.error("H5实例不存在")
      }
    },
    logout() {
      this.$store.dispatch("core/logout")
    },
    PadUserDetails() {
      this.$router.push({ name: "app-pad-user-details" })
    },
    onselect(item) {
      if (item.click) item.click(item)
      else if (item.route) {
        this.$router.push(item.route)
      }
    },
  },
  mounted() {
    let { cnname, username, userid } = this.$store.state.core.user
    this.cnname = cnname
    this.username = username
    this.userid = userid
    let _this = this
    fxImport("./web/config/core/myself/hook.config.js")
      .then((res) => {
        if (res.getNavMenus) {
          return res.getNavMenus(_this.list)
        }
      })
      .then((res) => {
        if (res) _this.$set(_this, "list", res)
      })
      .finally(() => {})
    // this.createAt = createAt;
  },
}
</script>
<style lang="scss" scoped>
.paduser {
  .paduser_item {
    padding-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .item__container {
      min-height: 50px;
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .img_box {
      width: 60px;
      height: 60px !important;
      border-radius: 16px;
    }
    .user__right {
      display: flex;
      margin-left: 10px;
      justify-content: space-around;
      flex-flow: column;
      flex-grow: 2;
    }
  }
}
</style>

<style lang="less">
.vertical-center-modal.pad-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: -50px !important;
  }
}
</style>